import useSWRMutation from 'swr/mutation';
import useSWR, {SWRConfiguration} from 'swr';
import aiTutorAPI from '../axiosInstance';
import {SessionResponse, SessionPayload, SessionDetails} from './types';

export function createAiTutorSessionRequest() {
  return useSWRMutation<SessionResponse, Error, string, SessionPayload>(
    `/sessions`,
    (url, {arg}) =>
      aiTutorAPI(url, {method: 'post', data: arg})
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
  );
}

export function fetchAiTutorSessionDetailsRequest(
  session_id?: number,
  config?: SWRConfiguration,
) {
  return useSWR<SessionDetails>(
    `/sessions/${session_id}`,
    (url) =>
      aiTutorAPI(url)
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
    {shouldRetryOnError: false, revalidateOnFocus: false, ...config},
  );
}
